// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__25IOe","signatureBlock":"Footer_signatureBlock__M62vq","signature":"Footer_signature__qS4wp"};